/** PHKL Custom -s
 * This file only for phkl GA
 * */

import { getAnalytics, logEvent, Analytics } from "firebase/analytics";
import { getPHKLGAFirebaseApp } from "../../../phkl-ga-firebase.config";
import {
  PHKLGAEventName,
  PHKLGAEventSource,
  PHKLGAFeature,
  PHKLGAModule,
  PHKLGAScreenName,
} from "./types/phkl-ga-parameter-type";
import {
  PHKLGAEventParameters,
  PHKLTakeUIClickEventParameters,
  PHKLTakeUIScreenViewEventParameters,
} from "./types/phkl-ga-general-type";
import { PHKLGetShortForm } from "./utils";

export const takePHKLGAUIScreenViewEvent = (parameters: PHKLTakeUIScreenViewEventParameters) => {
  const { module, feature, screen_name } = parameters;
  const screen_id = parameters.screen_id || getScreenId(module, feature, screen_name);

  takePHKLGAEvent("ui_screen_visit", {
    event_type: "Screen",
    ...parameters,
    module,
    feature,
    screen_name,
    screen_id,
  });
};

export const takePHKLGAUIClickEvent = (parameters: PHKLTakeUIClickEventParameters) => {
  const { module, feature, screen_name } = parameters;

  if (!module || !feature || !screen_name)
    throw new Error("Missing module or feature or screen_name");

  const screen_id = parameters.screen_id || getScreenId(module, feature, screen_name);

  takePHKLGAEvent("ui_click", {
    event_type: "Click",
    ...parameters,
    module,
    feature,
    screen_name,
    screen_id,
  });
};

const takePHKLGAEvent = (eventName: PHKLGAEventName, parameters: PHKLGAEventParameters) => {
  let analytics: Analytics;
  try {
    if (!getPHKLGAFirebaseApp()) {
      console.error("PHKL GA takePHKLGAEvent faild");
      return null;
    }
    analytics = getAnalytics(getPHKLGAFirebaseApp());
  } catch (error: any) {
    const errorMessage = error?.message || error?.toString() || String(error);
    console.error(`PHKL GA takePHKLGAEvent faild: ${errorMessage}`);
    return null;
  }

  const { module, feature, journey, stage } = parameters;
  const screen_class = `${module}_${feature}_${journey}_${stage}`;

  logEvent(analytics, eventName, {
    ...parameters,
    created_at: new Date(),
    event_source: PHKLGAEventSource,
    event_name: eventName,
    screen_class,
  });
};
const getScreenId = (
  module: PHKLGAModule,
  feature: PHKLGAFeature,
  screenName: PHKLGAScreenName,
) => {
  return `SCR${PHKLGetShortForm(module)}${PHKLGetShortForm(feature)}${PHKLGetShortForm(
    screenName,
  )}`;
};

// PHKL Custom -e
